import cn from 'classnames';

import {ImageTemplateProps} from '@/root/models/card';

interface Props extends ImageTemplateProps {
  alt: string;
}

const ImageTemplate = ({backgroundImageUrl, alt, onClickDetail, isThumbnail, isActive}: Props) => {
  return (
    <div className={cn('item_card', isActive && 'active')} style={{backgroundImage: `url(${backgroundImageUrl})`}}>
      <div className="inner_card">
        <div className="head_card">
          <strong className="screen_out" role="text">
            {alt}
          </strong>
        </div>
      </div>
      {!isThumbnail && (
        <button type="button" className="btn_view" onClick={onClickDetail}>
          <span className="screen_out">카드 상세 보기</span>
        </button>
      )}
    </div>
  );
};
export default ImageTemplate;
